<template>
  <table
    id="table"
    class="table"
  >
    <slot name="table-header"/>
    <colgroup>
      <slot name="colgroup"/>
    </colgroup>
    <thead>
      <tr>
        <slot
          name="thead"
          :columns="columns"
          :sortOrders="sortOrders"
          :sortBy="sortBy"
        />
      </tr>
    </thead>
    <tbody>
      <template v-for="(item, index) in filteredData">
        <slot name="tbody" :item="item" :index="index" :show="show" :openDetail="openDetail" :cols="cols"/>
      </template>
    </tbody>
    <tfoot>
      <template>
        <slot name="tfoot" :show="show" :cols="cols"/>
      </template>
    </tfoot>
  </table>
</template>

<script>
export default {
  name: "heim-table",
  props: {
    data: Array,
    col: String,
    cols: String,
    columns: Array,
    filterKey: String
  },
  data() {
    const columns = this.columns || [];
    const sortOrders = this.$route.params;

    this.columns.forEach(function (key) {
      sortOrders[key] = "asc"
    })

    return {
      sortKey: "",
      sortOrders: sortOrders,
      visibleDetailRows: []
    };
  },
  methods: {
    openDetail(item) {
      if (this.show(item))
        return (this.visibleDetailRows = this.visibleDetailRows.filter(id => {
          return item.id != id;
        }));
      this.visibleDetailRows.push(item.id);
    },
    show(item) {
      return this.visibleDetailRows.indexOf(item.id) >= 0;
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = (this.sortOrders[key] == "asc") ? "desc" : "asc";
      this.insertParam(key, this.sortOrders[key]);
    },
    insertParam(key, value) {
      value = (!value) ? "asc" : value;
      this.sortOrders[key] = value;

      let query = {};
      query[key] = value;

      this.$router.push({ path: this.$route.path, query: query });
    },
  },
  computed: {
    filteredData() {
      const sortKey = this.sortKey;
      const filterKey = this.filterKey && this.filterKey.toLowerCase();
      const order = (this.sortOrders[sortKey] == "asc") ? 1 : -1;

      let data = this.data;

      if (filterKey) {
        data = data.filter(row => {
          return Object.keys(row).some(key => {
            return (
              String(row[key])
                .toLowerCase()
                .indexOf(filterKey) > -1
            );
          });
        });
      }

      // get params url
      const params = this.$route.query;
      const key = Object.keys(params)[0];
      const value = Object.values(params)[0];

      // Check the params in the url and sort by increasing or decreasing order
      if (sortKey) {
        data = data.slice().sort((a, b) => {
          a = a[sortKey];
          b = b[sortKey];
          
          return (a === b ? 0 : a > b ? 1 : -1) * order;
        });
      } else if (key) {
        data = data.slice().sort((a, b) => {
          a = a[key];
          b = b[key];
          return (value == "asc") ? (a === b ? 0 : a > b ? -1 : 1) * order : (a === b ? 0 : a > b ? 1 : -1) * order;
        }); 
      }

      return data;
    }
  }
};
</script>

<style scoped>
table .label {
  display: inline-block;
  margin-bottom: 0;
  line-height: 28px;
}
table .collapse,
table .id,
table .edit,
table .activity,
table .badge,
table .server,
table .provider,
table th.details,
table .nb,
table .mail,
table .row-ctn .link {
  display: none;
}

.mobile-link {
  text-align: right;
  position: absolute;
  right: 0;
  top: 0;
  min-width: 5em;
  bottom: 0;
  display: initial;
}

.status {
  text-align: right;
  position: absolute;
  right: 0;
  min-width: 5em;
}

.chip {
  display: inline-block;
  width: 24px;
  height: 24px;
  border-radius: 100%;
  position: relative;
  right: 2em;
  top: 0.1em;
}
.mobile-link .link {
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

.icon-button.opened {
  transform: rotate(90deg);
}
.icon-button:hover {
  color: var(--heim-secondary-color);
}
.table .collapse,
.table .id {
  width: 5rem;
}
.table .main {
  width: 50%;
}
.table .action {
  width: 10rem;
}
table {
  border-collapse: collapse;
  margin: 0;
  padding: 0;
  width: 100%;
  table-layout: auto;
  border: none;
  box-shadow: var(--heim-shadow);
  overflow: hidden;
  border-radius: 8px;
}
table caption {
  font-size: 1.5em;
  margin: 0.5em 0 0.75em;
}
table th,
table td {
  font-size: 1em;
  padding: 0.625em;
  position: relative;
}
table th {
  font-size: 1em;
  font-weight: 700;
  letter-spacing: 0.1em;
  user-select: none;
}
table th.sortable {
  cursor: pointer;
  transition: color 0.3s ease;
}
table th.sortable:hover {
  color: var(--heim-secondary-color);
}
table tr {
  background-color: var(--heim-white-color);
  display: flex;
  padding: 0.35em;
  border-bottom: solid 1px #e3e9ed;
  position: relative;
}
table tbody {
  display: block;
}
table tbody tr:hover {
  background-color: #f2f5f7;
}
table td {
  display: flex;
  justify-content: space-between;
  font-size: 1em;
  text-align: right;
}
table td .row-ctn {
  text-align: left;
}
table .detail {
  margin-top: -1rem;
  box-shadow: inset 0 1px 3px #dbdbdb;
  background: #fafafa;
}
table .detail-container,
table td.detail-row {
  width: 100%;
}
table td .row-ctn {
  text-align: left;
}
  table td span {
    line-height: 28px;
  }

/* Wide layout: when the viewport width is bigger than 1024px, layout
changes to a wide layout. */
@media (min-width: 1025px) {
  table .collapse,
  table .id,
  table .edit,
  table .activity,
  table .server,
  table .provider,
  table .details,
  table .nb,
  table .mail,
  table .row-ctn .link {
    display: table-cell;
  }
  table .mobile-link,
  table .details {
    display: none;
  }
  table .badge {
    display: inline;
  }
  table .chip,
  table .only-mobile {
    display: none;
  }
  .status {
    position: relative;
  }
  table thead {
    display: table-header-group;
  }
  table tbody {
    display: table-row-group;
  }
  table th {
    text-align: left;
    background-color: #f2f5f7;
    border-bottom: solid 2px #e3e9ed;
  }
  table tr {
    display: table-row;
    text-align: left;
    margin: 0;
    padding: 0;
  }
  table td {
    display: table-cell;
    text-align: left;
  }
  .table .main {
    width: auto;
  }
  table td.detail-row {
    padding: 0.625em 1.2rem;
  }
  table .label {
    display: inline-block;
    margin-bottom: 0.3rem;
  }
  .edit .paper-action,
  .activity .paper-action {
    width: 6em;
    margin: 0 auto;
    opacity: 0;
    transition: opacity 0.1s ease-in-out;
  }

  table tr:hover .paper-action {
    opacity: 1;
  }
  table td .row-ctn {
    text-align: left;
    line-height: initial;
  }

  table .detail.only-mobile {
    display: none;
  }
}
</style>
<style>
table .row {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0.35em 1.5em;
}
.detail,
.detail-row {
  display: block;
}
td.detail-row .label {
  display: block;
  margin-bottom: 0.4rem;
  float: left;
}
.table .action .link {
  float: right;
}
td.detail-row .item {
  display: flex;
  justify-content: space-between;
}
/* Wide layout: when the viewport width is bigger than 1024px, layout
changes to a wide layout. */
@media (min-width: 1025px) {
  table .row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  table td.detail-row .label {
    display: block;
    float: none;
  }
  .detail {
    display: table-row;
  }
  .detail-row {
    display: table-cell;
  }
  td.detail-row .item {
    display: block;
  }
}
</style>
